import { copyToClipboard } from 'helpers/helpers';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { useDispatch } from 'store/hooks';

/**
 * A mutation to get a reset password URL for a given user ID.
 * @returns A mutation function that, when called with a user ID, sends a POST request to the server to get a reset password URL.
 */
export const useGetResetUrl = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    return useMutation({
        mutationKey: ['getResetUrl'],

        mutationFn: async (userId: number) => {
            const response = await RQAPICallWithData<{ url: string }>({
                endpoint: `auth/user/${userId}/reset_password`,
                method: 'POST',
            });
            return response.content.data;
        },

        onSuccess: (response) => {
            copyToClipboard(response.url);
            dispatch.vision.notifyUser({
                message: t('adminPanel.linkCopied'),
            });
        },
    });
};
